module.exports = __webpack_public_path__ + "static/img/3_9_2.b46aa36c.jpg";